import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const BookingPage = () => {
  const location = useLocation();
  const target = `/booking-day${location.search || ""}${location.hash || ""}`;
  return <Navigate to={target} replace />;
};

export default BookingPage;
